import { AuthService } from './../../service/auth.service';
import {CanLoad, Route,CanActivate,ActivatedRouteSnapshot,RouterStateSnapshot} from '@angular/router'
import {Injectable} from '@angular/core'
import { UserService } from 'src/app/services/user.service';

//import {LoginService} from '../login/login.service'
@Injectable()

export class LoggedInGuard implements  CanActivate{

constructor(private userService: UserService){}

checkAuthentication(path:string): boolean{
  
  const loggedIn = this.userService.isLoggedIn()
  
  if(path == "pre-cadastro-cliente"){
    return loggedIn
  }

  if(!loggedIn){
    this.userService.handleLogin(`/${path}`)
  }
  return loggedIn
}


canLoad(route: Route): boolean{
  
  return this.checkAuthentication(route.path)
}

canActivate(activatedRoute: ActivatedRouteSnapshot,
            routerState: RouterStateSnapshot):boolean{


  return this.checkAuthentication(activatedRoute.routeConfig.path)
}

}
